import { Link } from 'react-router-dom';

const entries = [
  {
    type: 'movie',
    label: '电影',
    desc: '院线佳作 · 口碑影片',
    icon: 'ri-film-line',
    ring: 'bg-primary-500/15 text-primary-500',
  },
  {
    type: 'tv',
    label: '电视剧',
    desc: '热播剧集 · 持续更新',
    icon: 'ri-tv-2-line',
    ring: 'bg-accent-500/15 text-accent-500',
  },
  {
    type: 'variety',
    label: '综艺',
    desc: '音乐美食 · 真人秀',
    icon: 'ri-mic-line',
    ring: 'bg-secondary-500/20 text-secondary-300',
  },
];

export default function CategoryEntries() {
  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-8 md:py-12">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        {entries.map((entry) => (
          <Link
            key={entry.type}
            to={`/category/${entry.type}`}
            className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-400/60"
          >
            <span
              className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-lg ${entry.ring}`}
            >
              <i className={`${entry.icon} text-2xl`} />
            </span>
            <div className="min-w-0 flex-1">
              <h3 className="text-base font-semibold text-foreground-50 transition-colors group-hover:text-primary-500">
                {entry.label}
              </h3>
              <p className="mt-1 text-sm text-foreground-500">{entry.desc}</p>
            </div>
            <i className="ri-arrow-right-line text-xl text-foreground-600 transition-transform group-hover:translate-x-1 group-hover:text-primary-500" />
          </Link>
        ))}
      </div>
    </section>
  );
}